import React from "react";

import { useTheme } from '@mui/material/styles';

function StoresIcon({ color: customColor, isActive }) {
    const theme = useTheme();

    const color = isActive ? '#fff' : (customColor || theme.palette.icons.color);

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <path stroke={color} strokeWidth={2} d="M4 10v7a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-7" />
            <path stroke={color} strokeLinejoin="round" strokeWidth={2} d="M2.632 5.576A3 3 0 0 1 5.602 3h12.796a3 3 0 0 1 2.97 2.576l.306 2.141A2 2 0 0 1 19.694 10H19c-1 0-2-2-2-2s-.5 2-2.5 2S12 8 12 8s-.5 2-2.5 2S7 8 7 8s-1 2-2 2h-.694a2 2 0 0 1-1.98-2.283l.306-2.141Z" />
            <rect width={8} height={4} x={8} y={13} stroke={color} strokeWidth={2} rx={1} />
        </svg>
    );
}

export default StoresIcon;
